import React, {useContext} from 'react';
import block from 'bem-cn-lite';
import {Button, Text, Avatar} from '@gravity-ui/uikit';
import {ArrowRightFromSquare} from '@gravity-ui/icons';
import {KeyboardCloseButton} from '@components/KeyboardNavigation';
import {AppContext} from '@app/context/context';
import AvatarIcon from '@assets/avatar-icon.svg';

import './UserCard.scss';

const b = block('user-card');

interface UserCardProps {
    onClose: () => void;
    onLogoutRequest?: () => void;
    highlightedIndex?: number;
}

export const UserCard: React.FC<UserCardProps> = ({
    onClose,
    onLogoutRequest,
    highlightedIndex = 0
}) => {
    const {state} = useContext(AppContext);
    const user = state.user;

    const getUserRoles = (roles: Record<string, boolean> | undefined) => {
        if (!roles) return '';
        return Object.entries(roles)
            .filter(([, isActive]) => isActive)
            .map(([role]) => role)
            .join(', ');
    };

    return (
        <div className={b()} role="menu" data-keyboard-trap>
            <div className={b('header')}>
                <Text variant="subheader-3">Профиль</Text>
                <KeyboardCloseButton onClose={onClose} className={b('close')} />
            </div>

            <div className={b('user')}>
                <div className={b('user-body')}>
                    <Avatar imgUrl={AvatarIcon} size="xl" />
                    <Text variant="subheader-1">{user?.displayName}</Text>
                    <Text variant="body-1" color="secondary">
                        {user?.email}
                    </Text>
                </div>

                <div className={b('user-body')}>
                    <Text variant="body-1">логин: {user?.login}</Text>
                    <Text variant="body-1">роль: {getUserRoles(user?.roles)}</Text>
                </div>
            </div>

            <Button
                size="l"
                className={b('button-exit', {highlighted: highlightedIndex === 0})}
                onClick={() => onLogoutRequest?.()}
                extraProps={{role: 'menuitem'}}
            >
                <ArrowRightFromSquare /> Выйти
            </Button>
        </div>
    );
};
